import { MouseEventHandler, VFC } from 'react';

import { UserCollector } from '@/apis/aniftyBackend/users/interface';
import TimesIcon from '@/icons/times.svg';

import styles from './CollectorList.module.scss';
import UserTab from './UserTab';

type Props = {
  collectors: UserCollector[];
  handleClose: MouseEventHandler;
};

const CollectorModal: VFC<Props> = ({ collectors, handleClose }: Props) => {
  return (
    <div className={styles.collectorModalBg}>
      <div className={styles.modalWrapper} onClick={handleClose}>
        <div>
          <div className={styles.modalHeader}>
            <div>Collectors {collectors.length}</div>
            <a>
              <TimesIcon
                height={24}
                width={24}
                style={{ display: 'block' }}
                onClick={handleClose}
              />
            </a>
          </div>
          {collectors.map((collector) => {
            return <UserTab key={collector.UserID} collector={collector} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default CollectorModal;
